module.exports = __webpack_public_path__ + "img/women-2-sm.c8921915.jpg";